import { Injectable } from '@angular/core';
import {
  DataService as CoreDataService,
  ObjectKey,
  PersistMode,
  PersistObjectModel,
  TargetColumnValue,
  TargetObjectData,
} from '@barthauer/abc/core/data';
import {   Task } from '@barthauer/custom/xmt-models';
import { Observable } from 'rxjs';
import { DataService, ObjectKeys } from '../../services/data.service';
import { HttpClient } from '@angular/common/http';
import { Email, ImageFile, Person } from './support-mail.model';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { map } from 'rxjs/operators';
import { ConvertHelper } from '@barthauer/abc/core';
import { environment } from '../../../../environments/environment';
import { AppService } from '../../services/app.service';
@Injectable()
export class SupportMailService {   
  private imagesToUpload: ImageFile[] = [];
  private  apiSendEmail: string;
  constructor(private dataService: DataService, 
    private coreDataService: CoreDataService,private http: HttpClient,  
     private configService: AbcConfigService,
    private appService :AppService) {

    const currentCongfiguration = configService.getConfiguration();
    this.apiSendEmail = currentCongfiguration.WebApi.ServiceURLs.SendEmail;
  }


  private convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  
  public async handleImageUpload(files: FileList): Promise<void> {
    const fileArray = Array.from(files);
    for (const file of fileArray) {
      const base64 = await this.convertToBase64(file);
      this.imagesToUpload.push({ file, base64 });
    }
  }

  public sendEmail(person: Person, description: string): Observable<any> {
    const imagesHtml = this.imagesToUpload.map(image => `<img src="${image.base64}" alt="Image" />`).join('<br/>');
     
    const email: Email = {
      From:  'support@aims-app.com',
      To:  environment.Email.technicalEmail ,
      Cc: [person.EMail,],
      Subject: `'Technical support' - ${person.EMail}`,
      Body: `Name : ${person.FullName}<br/><br/>
      Company : ${person.Company}<br/><br/>
      Description: ${description}<br/><br/><br/><br/>
      ${imagesHtml}`
    };
    return this.coreDataService
      .executeWebApiPOSTMethod(this.apiSendEmail, email)
      .pipe(map((data) => ConvertHelper.arrayBufferToObject(data)));
  }
 
  

  public prepareProfileCompany(): Observable<ArrayBuffer> {
    return this.dataService.readObjects(
      ObjectKeys.ADDRESS,
      [this.coreDataService.createQueryColumn('Id', 'Id'), this.coreDataService.createQueryColumn('Name', 'Name')],
      `Id ='${sessionStorage.getItem('profileAddressId')}'`
    );
  }

  public persisteTask(task: Task): Observable<ArrayBuffer> {
    const insertObjectData: TargetObjectData = new TargetObjectData();
    insertObjectData.ObjectKey = new ObjectKey();
    insertObjectData.ObjectKey.ObjectType = ObjectKeys.SUPPORTTASK;
    const addressPersonObjectColumns: TargetColumnValue[] = [
      { Name: 'ParentId', Value: task.ParentId },
      { Name: 'ParentObjectType', Value: ObjectKeys.ADDRESS },
      { Name: 'Body', Value: task.Body },
      { Name: 'Kind', Value: task.Kind },
      { Name: 'NetmeetingType', Value: task.NetmeetingType },
      { Name: 'StartDate', Value: task.StartDate },
      { Name: 'StartTime', Value: task.StartTime },
      { Name: 'Subject', Value: task.Subject },
      { Name: 'Type', Value: task.Type },
    ];

    insertObjectData.Mode = PersistMode.Insert;
    insertObjectData.TargetColumns = addressPersonObjectColumns;
    const persistObject: PersistObjectModel = new PersistObjectModel();
    persistObject.Object = insertObjectData;
    return this.coreDataService.executePersistObjectQuery(persistObject);
  }
}
